<!-- Linter does not detect that the component inside the header has content-->
<!-- eslint-disable vuejs-accessibility/heading-has-content -->
<template>
  <h3 class="heading-3">
    <FormattedMessage :definition="translations.title">
      <template #logo>
        <RevIllustration
          alt="BackUp logo"
          class="inline align-middle"
          :height="22"
          src="/img/insurance/backUpLogo.svg"
          :width="72"
        />
      </template>
    </FormattedMessage>
  </h3>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './Title.translations'
</script>
